<div class="modal-overlay" (click)="close.emit()">
  <div class="bulk-tag-modal" (click)="$event.stopPropagation()">
    <div class="bulk-tag-header">
      <div>
        <div class="bulk-tag-title">{{ bulkTagMode === 'add' ? 'Add tags to clients' : 'Remove tags from clients' }}</div>
        <div class="bulk-tag-subtitle">
          Tags will be {{ bulkTagMode === 'add' ? 'added to' : 'removed from' }}
          <strong>{{ selectedCount }} selected {{ selectedCount === 1 ? 'client' : 'clients' }}</strong>
        </div>
      </div>
      <button class="bulk-tag-close" (click)="close.emit()">&#x2715;</button>
    </div>

    <div class="bulk-tag-body">
      <div class="bulk-tag-section">
        <div class="bulk-tag-label">Selected clients:</div>
        <div class="bulk-tag-clients-preview">
          @for (c of selectedClients.slice(0, 6); track c.id) {
            <span class="client-name-chip">{{ c.name }}</span>
          }
          @if (selectedClients.length > 6) {
            <span class="client-name-chip">+ {{ selectedClients.length - 6 }} more</span>
          }
        </div>
      </div>

      <div class="bulk-tag-toggle">
        <div class="toggle-option" [class.toggle-active]="bulkTagMode === 'add'" (click)="bulkTagMode = 'add'; bulkTagSelections = []">Add tags</div>
        <div class="toggle-option" [class.toggle-active]="bulkTagMode === 'remove'" (click)="bulkTagMode = 'remove'; bulkTagSelections = []">Remove tags</div>
      </div>

      <div class="bulk-tag-label">Select tags to {{ bulkTagMode === 'add' ? 'add' : 'remove' }}:</div>
      <input class="bulk-tag-search" type="text" placeholder="Search or select tags..."
             [value]="bulkTagFilter"
             (input)="bulkTagFilter = $any($event.target).value" />

      <div class="bulk-tag-list">
        @for (tag of filteredBulkTags; track tag.id) {
          <div class="bulk-tag-row" [class.bulk-tag-row-selected]="isBulkTagSelected(tag.id)" (click)="toggleBulkTag(tag.id, $event)">
            <span class="bulk-check">
              @if (isBulkTagSelected(tag.id)) {
                <mat-icon class="bulk-check-icon">check</mat-icon>
              }
            </span>
            <span class="tag-pill">{{ tag.tag }}</span>
            <span class="bulk-tag-coverage">{{ coverageLabel(tag.id) }}</span>
          </div>
        }
        @if (filteredBulkTags.length === 0 && !showCreateOption) {
          <div class="bulk-tag-empty">No tags found</div>
        }
        @if (showCreateOption) {
          <div class="bulk-tag-row bulk-tag-create" (click)="createAndSelectTag()">
            <span class="bulk-check"><mat-icon class="bulk-check-icon">add</mat-icon></span>
            <span>Create tag "<strong>{{ bulkTagFilter.trim() }}</strong>"</span>
          </div>
        }
      </div>

      @if (bulkTagSelections.length > 0) {
        <div class="bulk-tag-summary">
          Will {{ bulkTagMode === 'add' ? 'add' : 'remove' }}
          <strong>{{ bulkTagSelections.length }} {{ bulkTagSelections.length === 1 ? 'tag' : 'tags' }}</strong>
          {{ bulkTagMode === 'add' ? 'to' : 'from' }}
          <strong>{{ selectedCount }} {{ selectedCount === 1 ? 'client' : 'clients' }}</strong>.
          {{ bulkTagMode === 'add' ? 'Clients that already have a tag will be skipped.' : "Clients that don't have a tag will be skipped." }}
        </div>
      }
    </div>

    <div class="bulk-tag-footer">
      <button class="bulk-footer-cancel" (click)="close.emit()">Cancel</button>
      <button class="bulk-footer-apply"
              [disabled]="bulkTagSelections.length === 0 || bulkTagApplying"
              (click)="applyBulkTags()">
        {{ bulkTagMode === 'add' ? 'Add' : 'Remove' }}
        @if (bulkTagSelections.length > 0) { {{ bulkTagSelections.length }} {{ bulkTagSelections.length === 1 ? 'tag' : 'tags' }} }
        @else { tags }
      </button>
    </div>
  </div>
</div>
